import React from "react";

function PageFooter() {
  return (
    <footer className="page-footer">
      <div className="page-footer__content">
        <span className="page-footer__brand">Federico Marchetti - jgothvalidator@gmail.com</span>
        <span className="page-footer__text">JGoth Validator · I dont own any of the girls shown here - but it is my dream · v0.1</span>
      </div>
    </footer>
  );
}

export default PageFooter;
